module.exports = __webpack_public_path__ + "static/media/picture5@2x.55f4728a.png";